import React from 'react';
import { Link } from "react-router-dom";
import Rating from 'react-rating';

import dayjs from 'dayjs';

import Labels from "../components/Labels";

import GlobalData from '../context/globaldata';

import StarBorder from '../images/icons/star-outline.svg';
import StarFill from '../images/icons/star-fill.svg';

class BrewListItem extends React.PureComponent {
  static contextType = GlobalData;

  render() {
    if(this.props.brew && this.context.currentUser) {
      return (
        <li className={`brew-item ${ this.props.isActive ? 'is-active' : '' }`}>
          <Link className="brew-item__container" to={`/brews/${ this.props.brew.uid }`}>
            <div className="brew-item__rating">
              <Rating
                initialRating={ this.props.brew.rating }
                fractions="2"
                emptySymbol={<img src={ StarBorder } className="favorite-icon" alt="" />}
                fullSymbol={<img src={ StarFill } className="favorite-icon" alt="" />}
                readonly
              />
            </div>
            <div className="brew-item__meta">
              <h3 className="brew-item__name">
                <span>{ this.props.brew.name }</span>
                <span className={`brew-item__favorite ${ this.props.brew.favorite ? 'is-visible' : '' }`}>
                  <i className="material-icons">favorite</i>
                </span>
              </h3>
              <div className="brew-item__origin">{ this.props.brew.origin }</div>
              <div className="brew-item__labels">
                <Labels labels={ this.props.brew.varietal }/>
              </div>
            </div>
            <div className="brew-item__date">
              { dayjs(this.props.brew.brew_date).format(this.context.userSettings.date_format) }
            </div>
          </Link>
        </li>
      )
    } else {
      return null
    }
  }
}

export default BrewListItem;
